<template>
  <div v-if="showDialog"
       class="festival-container" @click="handleClose">
    <div class="festival-box">
      <!-- <div class="header-box">
                <div class="close pointer" @click="handleClose">
                    &times;
                </div>
            </div> -->
      <div class="title">投保提醒</div>
      <div class="wrapper"
           ref="scroll"
           @scroll="onScroll">
        <div class="content rich-content"
             v-if="isRichText"
             v-html="content"></div>
        <div class="content plain-content"
             v-else>
          {{ content }}
        </div>
      </div>
      <div :class="{ 'button': true, 'pointer': true, 'disbtn': flag }"
           @click="handleClose">{{ flag ? '请上滑阅读完本条款' : '我已知晓' }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDialog: false,
      reachBottomDistance: 10,
      flag: true
    }
  },
  computed: {
    isRichText() {
      return /<[a-z][\s\S]*>/i.test(this.content)
    }
  },
  watch: {
    show: {
      handler(newval) {
        this.showDialog = newval
        if (newval) {
          this.flag = true
          this.$nextTick(this.checkScrollable)
        }
      },
      immediate: true
    },
    showDialog(newval) {
      this.$emit('update:show', newval)
    }
  },
  methods: {
    checkScrollable() {
      let el = this.$refs.scroll
      if (el && el.scrollHeight - el.getBoundingClientRect().height <= this.reachBottomDistance) {
        this.flag = false
      }
    },
    onScroll(e) {
      let scrollTop = e.target.scrollTop
      let scrollHeight = e.target.scrollHeight
      let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height)
      let currentHeight = scrollTop + offsetHeight + this.reachBottomDistance
      if (currentHeight >= scrollHeight && this.flag) {
        console.log('触底')
        this.flag = false
      }
    },
    handleClose() {
      // localStorage.setItem('sunnyNoticeClose', true)
      if (!this.flag) {
        this.showDialog = false
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.itembox
  line-height 17px
  color #565868
  font-size 12px
  border-radius 8px
  opacity 1
  background #F7F8FA
  padding 8px 10px
  box-sizing border-box
.deepblue-line
  background linear-gradient(90deg, #1C2A55 46%, #295886 100%)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
.flex-center
  align-items center
  display flex
  justify-content center
.deepblue
  color #1C2B55
.blue
  color #2EA1FF
.festival-container
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  background rgba(0, 0, 0, 0.7)
  z-index 100
.festival-box
  width 584px
  background-image url('../../assets/dialog/case-notice/bg-2.png')
  background-size 100% 100%
  position absolute
  height 548px
  left 50%
  top 45%
  transform translate(-50%, -50%)
.disbtn
  background #7FCAFF !important
.button
  width 170px
  height 35px
  line-height 35px
  background #0096FF
  border-radius 16px
  color #fff
  text-align center
  margin 12px auto 14px
.close
  position absolute
  right 20px
  top 40px
  font-size 32px
.fs-34
  font-size 34px
.header-box
  width 100%
  color #fff
.pd-b-15
  padding-bottom 15px
.pd-t-26
  padding-top 26px
.title
  position absolute
  left 0
  right 0
  top 124px
  text-align center
  font-size 22px
  font-weight 700
  color #0096ff
.wrapper ::-webkit-scrollbar
  display none
.wrapper
  padding 0 16px 10px
  margin-top 160px
  height 384px
  overflow auto
  box-sizing border-box
  scrollbar-width none
  -ms-overflow-style none
.plain-content
  white-space pre-line
.content-box
  border-radius 12px
  color #1F2021
.icon-dot
  display block
  width 12px
  flex-shrink 0
  height 12px
  background url('../../assets/dialog/case-notice/icon-dot-2.png') no-repeat
.mg-l-15
  margin-left 17px
.fc-lightgray
  color #686868
.fc-blue
  color #061EB6
</style>
